package reading

import UserProgress
import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import kotlin.collections.filter


@Composable
fun ReadingMenuScreen(
    onTaskSelected: (Int) -> Unit,
    onBack: () -> Unit
) {
    var userProgress by remember { mutableStateOf<List<UserProgress>>(emptyList()) }

    LaunchedEffect(Unit) {
        // Загружаем весь прогресс (все решенные сеты)
        userProgress = DataRepository.getMyPracticeProgressOnly()
    }
    val readingProgress = userProgress.filter { it.taskId <= 10 }
    // --- СЧИТАЕМ ОБЩУЮ СТАТИСТИКУ ---
    val totalSetsSolved = readingProgress.size
    val totalCorrect = readingProgress.sumOf { it.score }
    val totalQuestions = readingProgress.sumOf { it.totalQuestions }

    // Средняя точность (защита от деления на 0)
    val accuracy = if (totalQuestions > 0) (totalCorrect * 100 / totalQuestions) else 0

    // Уровень пользователя (простая геймификация)
    val userLevel = when {
        totalSetsSolved >= 20 -> "Experto 🎓"
        totalSetsSolved >= 10 -> "Avanzado 🚀"
        totalSetsSolved >= 5 -> "Intermedio ⭐"
        totalSetsSolved > 0 -> "Principiante 🌱"
        else -> "Nuevo usuario"
    }

    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            padding(20.px)
            backgroundColor(Color("#f0f2f5"))
            minHeight(100.vh)
        }
    }) {
        // --- ШАПКА ---
        Div({
            style {
                width(100.percent)
                maxWidth(800.px)
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.FlexStart)
                alignItems(AlignItems.Center)
                marginBottom(20.px)
                property("gap", "20px")
            }
        }) {
            Button({
                style {
                    backgroundColor(Color.white); border(0.px); fontSize(1.5.cssRem)
                    cursor("pointer"); padding(5.px, 15.px); borderRadius(20.px)
                    property("box-shadow", "0 2px 5px rgba(0,0,0,0.1)")
                }
                onClick { onBack() }
            }) { Text("⬅️") }

            H2({ style { margin(0.px); color(Color("#2c3e50")) } }) {
                Text("Menú de Práctica")
            }
        }

        // --- ИНФОРМАЦИОННАЯ ПАНЕЛЬ (DASHBOARD) ---
        Div({
            style {
                backgroundColor(Color.white)
                width(100.percent)
                maxWidth(800.px)
                borderRadius(16.px)
                padding(25.px)
                marginBottom(30.px)
                property("box-shadow", "0 4px 15px rgba(0,0,0,0.05)")
                display(DisplayStyle.Flex)
                justifyContent(JustifyContent.SpaceAround)
                property("flex-wrap", "wrap")
                property("gap", "20px")
            }
        }) {
            // Стат 1: Уровень
            StatItem(icon = "🏆", label = "Nivel", value = userLevel)

            // Стат 2: Решено сетов
            StatItem(icon = "📚", label = "Sets Resueltos", value = "$totalSetsSolved")

            // Стат 3: Точность
            StatItem(icon = "🎯", label = "Precisión", value = "$accuracy%", valueColor = if(accuracy > 70) "#27ae60" else "#e67e22")
        }

        // --- СПИСОК ЗАДАЧ (GRID) ---
        Div({
            style {
                display(DisplayStyle.Grid)
                property("grid-template-columns", "repeat(auto-fill, minmax(300px, 1fr))")
                property("gap", "20px")
                width(100.percent)
                maxWidth(800.px)
            }
        }) {
            for (i in 1..5) {
                // Находим ВСЕ решения для текущей Tarea (например, пользователь решил 3 разных сета Tarea 1)
           //     val taskHistory = userProgress.filter { it.taskId == i }
                val taskHistory = readingProgress.filter { it.taskId == i }
                val countSolved = taskHistory.size

                // Считаем лучший результат для этой задачи
                val bestScore = if (countSolved > 0) taskHistory.maxOf { it.score } else 0
                val maxPossible = if (countSolved > 0) taskHistory.first().totalQuestions else 0 // Берем из любой записи

                TaskCard(
                    number = i,
                    title = getTaskTitle(i),
                    solvedCount = countSolved,
                    bestScoreText = if (countSolved > 0) "$bestScore/$maxPossible (Mejor)" else "",
                    onClick = { onTaskSelected(i) }
                )
            }
        }
    }
}

// Компонент для одного показателя статистики
@Composable
fun StatItem(icon: String, label: String, value: String, valueColor: String = "#2c3e50") {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            minWidth(100.px)
        }
    }) {
        Div({ style { fontSize(2.cssRem); marginBottom(5.px) } }) { Text(icon) }
        Span({ style { color(Color("#7f8c8d")); fontSize(0.9.cssRem); marginBottom(5.px) } }) { Text(label) }
        Span({ style { color(Color(valueColor)); fontSize(1.2.cssRem); fontWeight("bold") } }) { Text(value) }
    }
}

@Composable
fun TaskCard(
    number: Int,
    title: String,
    solvedCount: Int,
    bestScoreText: String,
    onClick: () -> Unit
) {
    val isSolvedAtLeastOnce = solvedCount > 0

    Div({
        onClick { onClick() }
        style {
            backgroundColor(Color.white)
            padding(20.px)
            borderRadius(12.px)
            property("box-shadow", "0 4px 6px rgba(0,0,0,0.05)")
            cursor("pointer")
            property("transition", "transform 0.2s")
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.SpaceBetween)
            alignItems(AlignItems.Center)
            // Цветная полоска слева в зависимости от типа задачи
            property("border-left", "5px solid ${getTaskColor(number)}")
        }
        attr("onmouseover", "this.style.transform='translateY(-3px)'")
        attr("onmouseout", "this.style.transform='translateY(0)'")
    }) {
        // Левая часть: Название
        Div {
            H3({ style { margin(0.px); marginBottom(5.px); color(Color("#34495e")) } }) {
                Text("Tarea $number")
            }
            Span({ style { color(Color("#7f8c8d")); fontSize(0.9.cssRem) } }) {
                Text(title)
            }

            // Если решено хоть раз, показываем счетчик
            if (isSolvedAtLeastOnce) {
                Div({ style { marginTop(10.px); fontSize(0.85.cssRem); color(Color("#16a085")); display(DisplayStyle.Flex); alignItems(AlignItems.Center) } }) {
                    Text("✅ $solvedCount sets completados")
                }
            } else {
                Div({ style { marginTop(10.px); fontSize(0.85.cssRem); color(Color("#bdc3c7")) } }) {
                    Text("⚪ Aún no iniciado")
                }
            }
        }

        // Правая часть: Лучший результат или Стрелка
        Div({ style { textAlign("right") } }) {
            if (isSolvedAtLeastOnce) {
                Div({ style { fontSize(0.8.cssRem); color(Color("#7f8c8d")) } }) { Text("Récord:") }
                Span({ style { fontSize(1.1.cssRem); color(Color("#2c3e50")); fontWeight("bold") } }) {
                    Text(bestScoreText)
                }
            } else {
                Div({
                    style {
                        width(35.px); height(35.px); borderRadius(50.percent)
                        backgroundColor(Color("#ecf0f1"))
                        display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
                        color(Color("#bdc3c7"))
                    }
                }) { Text("➜") }
            }
        }
    }
}

fun getTaskTitle(number: Int): String {
    return when (number) {
        1 -> "Textos breves"
        2 -> "Texto largo"
        3 -> "Relacionar textos"
        4 -> "Espacios en blanco"
        5 -> "Reconstrucción"
        else -> "Tarea"
    }
}
// Цвета для полосок карточек (для красоты)
fun getTaskColor(number: Int): String {
    return when (number) {
        1 -> "#3498db" // Blue
        2 -> "#9b59b6" // Purple
        3 -> "#e67e22" // Orange
        4 -> "#e74c3c" // Red
        5 -> "#1abc9c" // Teal
        else -> "#95a5a6"
    }
}